<button (click)="saveDataToCsv()" mat-raised-button color="primary" class="saveToButton">Save to csv</button>
